import * as SplashScreen from 'expo-splash-screen'
import { Box, Center } from 'native-base'
import React, { FC, PropsWithChildren, useCallback } from 'react'

import { Loader } from './LoadingState'

import { useAuth, useBoolean, useCachedResources, useEffect } from '~hooks'

SplashScreen.preventAutoHideAsync()

export const AppLoading: FC<PropsWithChildren> = ({ children }) => {
  const [isDelayLoading, setIsDelayLoading] = useBoolean(true)
  const isLoadingComplete = useCachedResources()
  const { isSignedIn } = useAuth()

  const isLoading = !isLoadingComplete || isSignedIn === null

  const onLayoutRootView = useCallback(async () => {
    try {
      // Source: https://docs.expo.dev/versions/latest/sdk/splash-screen/#usage
      // This tells the splash screen to hide immediately! If we call this after
      // `prepare`, then we may see a blank screen while the app is
      // loading its initial state and rendering its first pixels. So instead,
      // we hide the splash screen once we know the root view has already
      // performed layout.
      await SplashScreen.hideAsync()
    } catch {
      console.log('There was some error while hiding splash screen')
    }
  }, [])

  useEffect(() => {
    async function prepare() {
      try {
        // Keep the splash screen visible while we fetch resources
        await SplashScreen.preventAutoHideAsync()
      } catch (e) {
        console.warn(e)
      }
    }

    prepare()
  }, [])

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setIsDelayLoading.off()
      }, 200)
    }
  }, [isLoading, setIsDelayLoading])

  return (
    <Box flex={1} onLayout={onLayoutRootView}>
      {isLoading || isDelayLoading ? (
        <Center flexGrow={1}>
          <Loader />
        </Center>
      ) : (
        children
      )}
    </Box>
  )
}
